import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { string } from 'prop-types';
import React, { useRef, useEffect, useState } from 'react';

const textSx = {
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const OverflowTip = props => {
  const [hoverStatus, setHover] = useState(false);
  const textElementRef = useRef();

  const compareSize = () => {
    const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
  }, []);

  useEffect(
    () => () => {
      window.removeEventListener('resize', compareSize);
    },
    [],
  );

  return (
    <Tooltip title={props.value} interactive disableHoverListener={!hoverStatus}>
      <Box component="span" ref={textElementRef} sx={textSx}>
        {props.value}
      </Box>
    </Tooltip>
  );
};

OverflowTip.propTypes = {
  value: string.isRequired,
};

export default OverflowTip;
